import { ThemeEnum } from '@app/common';

const lightAssetColors = {
    blue: {
        light: '#6B98FF',
        main: '#3347FF',
        dark: '#0000C1',
    },
    purple: {
        light: '#969BFF',
        main: '#6D73F5',
        dark: '#44489F',
    },
    green: {
        light: '#7FD3B6',
        main: '#15BE96',
        dark: '#229070',
    },
    primary: {
        light: '#63B3F9',
        main: '#2289F6',
        dark: '#0062C5',
    },
    secondary: {
        light: '#524B83',
        main: '#231D61',
        dark: '#281E4E',
    },
    gray: {
        light: '#D9D9E0',
        main: '#9B9CAB',
        dark: '#575761',
    },
    orange: {
        light: '#FFC97C',
        main: '#FCA842',
        dark: '#F77833',
    },
    red: {
        light: '#FF9FAA',
        main: '#FF687B',
        dark: '#EC495E',
    },
    pink: {
        light: '#DC75B0',
        main: '#C13584',
        dark: '#A11866',
    },
    brown: {
        light: '#8C5849',
        main: '#623223',
        dark: '#592616',
    },
    yellow: {
        light: '#FFE97A',
        main: '#EAC300',
        dark: '#A97600',
    },
};

export const assetColors = {
    [ThemeEnum.Light]: lightAssetColors,
    [ThemeEnum.Dark]: {
        ...lightAssetColors,
        secondary: {
            light: '#BFC1F4',
            main: '#A4A6EC',
            dark: '#7A7ACE',
        },
    },
};
